import React from 'react';
import Button from '@prisjakt/ui-button';
import Chevron from 'mdi-react/ChevronRightIcon';
import T from '@prisjakt/ui-translate';
import * as S from './styles';

type Props = {
  onClick: () => void;
  query: string;
  selected: boolean;
};

export default ({ selected, onClick, query }: Props) => {
  return (
    <S.Item selected={selected} onClick={onClick}>
      <S.OriginalQuery selected={selected} data-test="BestSuggestion">
        <span>
          <T domain="search">suggest.title-best</T> <i>{query}</i>
        </span>
        <Button
          disabled={query.length < 2}
          color="secondary"
          variant="icon"
          icon={<Chevron />}
        />
      </S.OriginalQuery>
    </S.Item>
  );
};
